/**
 * =============================================
 * MEGA MENU JAVASCRIPT - V2
 * File: assets/mega-menu.js
 * 
 * Handles:
 * - Category hover (Column 1 → Column 2)
 * - Collection hover (Column 2 → Column 3)
 * - Dynamic content updates for all columns
 * - Keyboard navigation
 * =============================================
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }

  function initMegaMenu() {
    const megaMenuItems = document.querySelectorAll('.mega-menu-item.has-mega-dropdown');

    if (!megaMenuItems.length) return;

    megaMenuItems.forEach((menuItem) => {
      const dropdown = menuItem.querySelector('.mega-dropdown');
      if (!dropdown) return;

      const categoryItems = dropdown.querySelectorAll('.mega-category-item.has-subcategories');
      const productsColumn = dropdown.querySelector('.mega-column-products');
      const collectionProductsColumn = dropdown.querySelector('.mega-column-collection-products');
      const bannersColumn = dropdown.querySelector('.mega-column-banners');

      // Show first category by default
      if (categoryItems.length > 0) {
        const firstCategory = categoryItems[0];
        const firstHandle = firstCategory.dataset.categoryHandle;
        showContentForCategory(firstHandle, productsColumn, collectionProductsColumn, bannersColumn);
        firstCategory.classList.add('active');
        
        // Show first collection's products by default
        setTimeout(() => {
          const firstCollectionLink = productsColumn.querySelector('.mega-product-link');
          if (firstCollectionLink) {
            const collectionHandle = firstCollectionLink.dataset.collectionHandle;
            showCollectionProducts(collectionHandle, firstHandle, collectionProductsColumn);
            firstCollectionLink.classList.add('active');
          }
        }, 50);
      }

      // Category hover events (Column 1)
      categoryItems.forEach((categoryItem) => {
        categoryItem.addEventListener('mouseenter', function () {
          const handle = this.dataset.categoryHandle;

          // Remove active from all categories
          categoryItems.forEach((item) => item.classList.remove('active'));
          this.classList.add('active');

          // Show corresponding collections and banners
          showContentForCategory(handle, productsColumn, collectionProductsColumn, bannersColumn);
        });
      });

      // Collection hover events (Column 2)
      setupCollectionHoverEvents(dropdown);

      // Reset when leaving dropdown
      dropdown.addEventListener('mouseleave', function () {
        if (categoryItems.length > 0) {
          categoryItems.forEach((item) => item.classList.remove('active'));
          const firstCategory = categoryItems[0];
          const firstHandle = firstCategory.dataset.categoryHandle;
          showContentForCategory(firstHandle, productsColumn, collectionProductsColumn, bannersColumn);
          firstCategory.classList.add('active');
          
          // Reset to show first collection's products
          setTimeout(() => {
            const firstCollectionLink = productsColumn.querySelector('.mega-product-link');
            if (firstCollectionLink) {
              const collectionHandle = firstCollectionLink.dataset.collectionHandle;
              showCollectionProducts(collectionHandle, firstHandle, collectionProductsColumn);
              firstCollectionLink.classList.add('active');
            }
          }, 50);
        }
      });
    });

    setupKeyboardNavigation();
  }

  /**
   * Show collections and banners for specific category
   */
  function showContentForCategory(handle, productsColumn, collectionProductsColumn, bannersColumn) {
    if (!handle || !productsColumn || !bannersColumn) return;

    // Hide all collection sections
    const allProductSections = productsColumn.querySelectorAll('.mega-products-section, .mega-products-placeholder');
    allProductSections.forEach((section) => {
      section.style.display = 'none';
    });

    // Show matching collection section
    const targetProductSection = productsColumn.querySelector(`[data-section-handle="${handle}"]`);
    if (targetProductSection) {
      targetProductSection.style.display = 'block';
      
      // Setup hover events for collection links in this section
      const collectionLinks = targetProductSection.querySelectorAll('.mega-product-link');
      collectionLinks.forEach((link) => {
        link.addEventListener('mouseenter', function() {
          const collectionHandle = this.dataset.collectionHandle;
          const parentHandle = handle;
          showCollectionProducts(collectionHandle, parentHandle, collectionProductsColumn);
          
          // Add active state
          collectionLinks.forEach(l => l.classList.remove('active'));
          this.classList.add('active');
        });
      });
      
      // Show first collection's products by default
      setTimeout(() => {
        const firstCollectionLink = targetProductSection.querySelector('.mega-product-link');
        if (firstCollectionLink && collectionProductsColumn) {
          const collectionHandle = firstCollectionLink.dataset.collectionHandle;
          showCollectionProducts(collectionHandle, handle, collectionProductsColumn);
          firstCollectionLink.classList.add('active');
        }
      }, 50);
    } else {
      const placeholder = productsColumn.querySelector('.mega-products-placeholder');
      if (placeholder) placeholder.style.display = 'flex';
      
      // Hide collection products when no collections available
      if (collectionProductsColumn) {
        const allCollectionSections = collectionProductsColumn.querySelectorAll('.mega-collection-products-section, .mega-collection-products-placeholder');
        allCollectionSections.forEach((section) => {
          section.style.display = 'none';
        });
        const collectionPlaceholder = collectionProductsColumn.querySelector('.mega-collection-products-placeholder');
        if (collectionPlaceholder) collectionPlaceholder.style.display = 'flex';
      }
    }

    // Hide all banner sections
    const allBannerSections = bannersColumn.querySelectorAll('.mega-banner-section, .mega-banner-placeholder');
    allBannerSections.forEach((section) => {
      section.style.display = 'none';
    });

    // Show matching banner section
    const targetBannerSection = bannersColumn.querySelector(`[data-banner-handle="${handle}"]`);
    if (targetBannerSection && targetBannerSection.children.length > 0) {
      targetBannerSection.style.display = 'flex';
    } else {
      const placeholder = bannersColumn.querySelector('.mega-banner-placeholder');
      if (placeholder) placeholder.style.display = 'flex';
    }
  }

  /**
   * Show products for specific collection
   */
  function showCollectionProducts(collectionHandle, parentHandle, collectionProductsColumn) {
    if (!collectionProductsColumn || !collectionHandle) return;

    // Hide all collection product sections
    const allSections = collectionProductsColumn.querySelectorAll('.mega-collection-products-section, .mega-collection-products-placeholder');
    allSections.forEach((section) => {
      section.style.display = 'none';
    });

    // Find and show matching collection products section
    const targetSection = collectionProductsColumn.querySelector(
      `[data-collection-handle="${collectionHandle}"][data-parent-handle="${parentHandle}"]`
    );
    
    if (targetSection) {
      targetSection.style.display = 'block';
    } else {
      // Show placeholder if no products found
      const placeholder = collectionProductsColumn.querySelector('.mega-collection-products-placeholder');
      if (placeholder) placeholder.style.display = 'flex';
    }
  }

  /**
   * Setup collection hover events
   */
  function setupCollectionHoverEvents(dropdown) {
    const collectionLinks = dropdown.querySelectorAll('.mega-product-link');
    const collectionProductsColumn = dropdown.querySelector('.mega-column-collection-products');

    collectionLinks.forEach((link) => {
      link.addEventListener('mouseenter', function() {
        const collectionHandle = this.dataset.collectionHandle;
        const parentSection = this.closest('.mega-products-section');
        const parentHandle = parentSection ? parentSection.dataset.sectionHandle : null;
        
        if (collectionHandle && parentHandle) {
          showCollectionProducts(collectionHandle, parentHandle, collectionProductsColumn);
          
          // Add active state to current link
          const allCollectionLinks = parentSection.querySelectorAll('.mega-product-link');
          allCollectionLinks.forEach(l => l.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });
  }

  /**
   * Keyboard Navigation
   */
  function setupKeyboardNavigation() {
    const megaMenuLinks = document.querySelectorAll('.mega-menu-link');
    const categoryLinks = document.querySelectorAll('.mega-category-link');
    const productLinks = document.querySelectorAll('.mega-product-link');

    // Main menu navigation
    megaMenuLinks.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        const parent = link.closest('.mega-menu-item');
        const dropdown = parent.querySelector('.mega-dropdown');

        if ((e.key === 'Enter' || e.key === ' ') && dropdown) {
          e.preventDefault();
          parent.classList.add('active');
          link.setAttribute('aria-expanded', 'true');

          const firstCategoryLink = dropdown.querySelector('.mega-category-link');
          if (firstCategoryLink) {
            setTimeout(() => firstCategoryLink.focus(), 100);
          }
        }

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const nextItem = megaMenuLinks[index + 1];
          if (nextItem) nextItem.focus();
        }

        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prevItem = megaMenuLinks[index - 1];
          if (prevItem) prevItem.focus();
        }

        if (e.key === 'Escape') {
          parent.classList.remove('active');
          link.setAttribute('aria-expanded', 'false');
          link.focus();
        }
      });
    });

    // Category navigation
    categoryLinks.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const nextLink = categoryLinks[index + 1];
          if (nextLink) nextLink.focus();
        }

        if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prevLink = categoryLinks[index - 1];
          if (prevLink) prevLink.focus();
        }

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const dropdown = link.closest('.mega-dropdown');
          const firstProductLink = dropdown.querySelector('.mega-product-link');
          if (firstProductLink) firstProductLink.focus();
        }

        if (e.key === 'Escape') {
          const menuItem = link.closest('.mega-menu-item');
          const mainLink = menuItem.querySelector('.mega-menu-link');
          menuItem.classList.remove('active');
          mainLink.setAttribute('aria-expanded', 'false');
          mainLink.focus();
        }
      });
    });

    // Product/Collection navigation
    productLinks.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const nextLink = productLinks[index + 1];
          if (nextLink) nextLink.focus();
        }

        if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prevLink = productLinks[index - 1];
          if (prevLink) prevLink.focus();
        }

        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const dropdown = link.closest('.mega-dropdown');
          const activeCategory = dropdown.querySelector('.mega-category-item.active .mega-category-link');
          if (activeCategory) activeCategory.focus();
        }

        if (e.key === 'Escape') {
          const menuItem = link.closest('.mega-menu-item');
          const mainLink = menuItem.querySelector('.mega-menu-link');
          menuItem.classList.remove('active');
          mainLink.setAttribute('aria-expanded', 'false');
          mainLink.focus();
        }
      });
    });
  }

  /**
   * =============================================
   * BANNER SLIDERS
   * =============================================
   * Initialises every .mega-banner-slider found in
   * the document.  Safe to call multiple times —
   * already-initialised sliders are skipped via a
   * data attribute.
   */
  function initBannerSliders() {
    const sliders = document.querySelectorAll('.mega-banner-slider:not([data-slider-ready])');

    sliders.forEach((sliderEl) => {
      sliderEl.setAttribute('data-slider-ready', '1');

      const slides   = Array.from(sliderEl.querySelectorAll('.mega-banner-slide'));
      const dots     = Array.from(sliderEl.querySelectorAll('.mega-slider-dot'));
      const prevBtn  = sliderEl.querySelector('.mega-slider-prev');
      const nextBtn  = sliderEl.querySelector('.mega-slider-next');
      const pauseBtn = sliderEl.querySelector('.mega-slider-pause');
      const iconPause = pauseBtn ? pauseBtn.querySelector('.icon-pause') : null;
      const iconPlay  = pauseBtn ? pauseBtn.querySelector('.icon-play')  : null;

      if (slides.length < 2) return; // nothing to slide

      const delay = parseInt(sliderEl.dataset.autoplay, 10) || 4000;
      let current  = 0;
      let paused   = false;
      let timer    = null;

      /* ---- helpers ---- */
      function goTo(index) {
        slides[current].classList.remove('is-active');
        dots[current] && dots[current].classList.remove('is-active');

        current = (index + slides.length) % slides.length;

        slides[current].classList.add('is-active');
        dots[current] && dots[current].classList.add('is-active');
      }

      function startTimer() {
        clearInterval(timer);
        timer = setInterval(() => {
          if (!paused) goTo(current + 1);
        }, delay);
      }

      function stopTimer() {
        clearInterval(timer);
        timer = null;
      }

      /* ---- auto-play ---- */
      startTimer();

      /* Pause when the mega dropdown is not visible (saves CPU) */
      const dropdown = sliderEl.closest('.mega-dropdown');
      if (dropdown) {
        const observer = new MutationObserver(() => {
          const visible = getComputedStyle(dropdown).opacity !== '0';
          visible ? startTimer() : stopTimer();
        });
        observer.observe(dropdown, { attributes: true, attributeFilter: ['style', 'class'] });
      }

      /* ---- controls ---- */
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(current - 1);
          startTimer(); // reset interval on manual nav
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(current + 1);
          startTimer();
        });
      }

      if (pauseBtn) {
        pauseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          paused = !paused;
          pauseBtn.setAttribute('aria-label', paused ? 'Play slider' : 'Pause slider');
          if (iconPause) iconPause.style.display = paused ? 'none'  : '';
          if (iconPlay)  iconPlay.style.display  = paused ? ''      : 'none';
        });
      }

      dots.forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goTo(i);
          startTimer();
        });
      });

      /* Pause on hover over the slider itself */
      sliderEl.addEventListener('mouseenter', () => stopTimer());
      sliderEl.addEventListener('mouseleave', () => { if (!paused) startTimer(); });
    });
  }

  // Run after mega menu is initialised
  initBannerSliders();

  /**
   * Close dropdown when clicking outside
   */
  document.addEventListener('click', (e) => {
    const megaMenuItems = document.querySelectorAll('.mega-menu-item.has-mega-dropdown');
    
    megaMenuItems.forEach((item) => {
      if (!item.contains(e.target)) {
        item.classList.remove('active');
        const link = item.querySelector('.mega-menu-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /**
   * Handle window resize
   */
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth <= 768) {
        const megaMenuItems = document.querySelectorAll('.mega-menu-item.has-mega-dropdown');
        megaMenuItems.forEach((item) => {
          item.classList.remove('active');
          const link = item.querySelector('.mega-menu-link');
          if (link) link.setAttribute('aria-expanded', 'false');
        });
      }
    }, 250);
  });

})();
